import React from 'react';
import cx from 'classnames';

import GenericStateNoActionBlock from '../../blocks/GenericStateNoActionBlock';

import styles from './ExpiredStatePage.module.scss';
import usePresenter from './ExpiredStatePage.presenter';
import getProps from './ExpiredStatePage.props';
import { ExpiredStatePageCombinedProps } from './types';


const ExpiredStatePage: React.FC<ExpiredStatePageCombinedProps> = (props) => {
  const {
    className,
    classes,
    genericStateNoActionBlock,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.expiredStatePage;

  return (
    <div className={cx(currentStyle, className)}>
      <GenericStateNoActionBlock
        className={cx(styles.genericStateNoActionBlock, classes?.genericStateNoActionBlock)}
        {...internalProps.genericStateNoActionBlock}
        {...genericStateNoActionBlock}/>
    </div>
  );
};

export default ExpiredStatePage;

